import { render, staticRenderFns } from "./TrafficTable.vue?vue&type=template&id=b5c2d560"
import script from "./TrafficTable.vue?vue&type=script&lang=js"
export * from "./TrafficTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports